import React from "react";

import "./EmptyListView.css";

export interface EmptyListViewProps {
    title?: string | null;
    message: string;
}

export const EmptyListView = ({title, message}: EmptyListViewProps) => {
    return (
        <div className="EmptyListView">
            {title ? <span className="EmptyListTitle">{title}</span> : null}
            <div className="EmptyListMessage">
                {message}
            </div>
        </div>
    );
};
